import React, { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import axios from "axios";
import "./Marquee.css";  

// Import images
import CoolIshr from "./assets/Cool-Ishrae-e1715666840667-2048x717.png";
import ACREX from "./assets/Arex.png";
import Peda from "./assets/logopde.png";
import MANU from "./assets/MANU.jpg";
import WefixLogo11 from "./assets/logo10.png";
import LogoD2o from "./assets/logoD2o.png"; 
import LogoDIAS from "./assets/logoDIAS.svg";
import RajisthanLOgo11 from "./assets/Rj.jpeg";
import Griha from "./assets/griha.jpg";

const MarqueeImg = () => {
  const [countryCode, setCountryCode] = useState("");

  useEffect(() => {
    axios.get("https://ipapi.co/json/")
      .then(response => {
        setCountryCode(response.data.country);
      })
      .catch(error => console.error("Error fetching location:", error));
  }, []);

  // Define image list with conditional filtering
  const images = [
    { src: CoolIshr, alt: "Cool Ishr" },
    { src: ACREX, alt: "ACREX" },
    { src: Peda, alt: "Peda", hideFor: ["CA"] },
    { src: MANU, alt: "MANU" },
    { src: WefixLogo11, alt: "WeFix Logo" },
    { src: RajisthanLOgo11, alt: "Rising Rajasthan Logo" },
    { src: LogoDIAS, alt: "Logo DIAS" },
    { src: Griha, alt: "Logo Griha" },
    { src: LogoD2o, alt: "Logo D2o", hideFor: ["CA"] }
  ];

  // Filter out images that should be hidden for a specific country
  const filteredImages = images.filter(img => !img.hideFor?.includes(countryCode));

  return (
    <div className="marquee-container">
      <Marquee speed={30} direction="left" delay={0.2}>
        {filteredImages.map((img, index) => (
          <img key={index} src={img.src} alt={img.alt} className="marquee-image" />
        ))}
      </Marquee>
    </div>
  );
};

export default MarqueeImg;
